<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
				<b-o-grid 
					:filters="filters"
					:columns="columns"
					:datakey="'id'"
					:title="'Phd Scholarship Applications'"
					:dialogType="'AssignmentC16Dialog'"
					:canAdd=false
					:canEdit=true
					:canDelete=false
					:findElementIndex="findElementIndex"
					:canEditFunction="canEditOrDeleteFunction"
					:canDeleteFunction="canEditOrDeleteFunction"
					:fetchData="getData"
					:updateFunction="saveRecord"
					:exportFilename="'Evaluation of Archimedes 1st Call PhD Scholarships'"

				></b-o-grid>
			</div>

		</div>
		
	</div>

</template>

<script>
import BOGrid from '../components/BOGrid.vue'
import { mapGetters } from 'vuex'
import { httpClient } from '../api/httpClient'

export default {
  components: { BOGrid },
	data() {
		return {
			records: null,
			filters: [],
			submitted: false,
			comments: "",
			loading: true,
			columns: [
				{field: 'submissionId', header: 'Application ID', sortable: true},
				{field: 'title', header: 'PhD candidate', sortable: true},
				{field: 'Supervisor', header: 'Supervisor', sortable: true, hidden: true},
				{field: 'comment', header: 'Comment'},                
				{field: 'recommended', header: 'Recommended', sortable: true},
				{field: 'ranking', header: 'Ranking', sortable: true},
				{field: 'isCompleted', header: 'Finalized', sortable: true, hidden: false},
				
			],
			title: "Phd Scholarships Applications",
		}
	},
	methods: {
		formatCurrency(value) {
			if(value)
				return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
			return;
		},
		exportCSV() {
			this.$refs.dt.exportCSV();
		},
        findElementIndex(arr, obj) {
            return arr.findIndex(x => x.id == obj.id )
        },	
		canEditOrDeleteFunction(x) {
			return !x.isCompleted
		},
		getData(refresh) {
            return new Promise( (resolve, reject) => {
				
				if(!refresh) {
					if(this.records == null) {
						refresh = true
					}
					else
						resolve(this.records)
				}

				if(refresh) {
					httpClient.get("api/assignments")
					.then((response) => {
						this.records = response.data
						resolve(response.data)
					}, error => {
						reject(error)
					})
				}				
            })
		},
		saveRecord(record, finalize) {
			return new Promise( (resolve, reject) => {
				var index = this.findElementIndex(this.records, record)
				httpClient.put("api/assignments/" + finalize, record)
				.then((response) => {
					this.records[index] = {...response.data}
					resolve(response)
				},
				error => {
					reject(error)
				})
			})
		}
    },
	computed: {
		...mapGetters(["getModuleSetup"])
	},
	created() {
		//this.module = this.getModuleSetup("staff")
	}		     
}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}

	.product-image {
		width: 100px;
		box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
	}

	.p-dialog .product-image {
		width: 150px;
		margin: 0 auto 2rem auto;
		display: block;
	}

	.confirmation-content {
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.product-badge {
		border-radius: 2px;
		padding: .25em .5rem;
		text-transform: uppercase;
		font-weight: 700;
		font-size: 12px;
		letter-spacing: .3px;

		&.status-instock {
			background: #C8E6C9;
			color: #256029;
		}

		&.status-outofstock {
			background: #FFCDD2;
			color: #C63737;
		}

		&.status-lowstock {
			background: #FEEDAF;
			color: #8A5340;
		}
	}

	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
		.p-button {
			margin-bottom: .25rem;
		}
	}
</style>
